<template>
  <div class="text-center">
    <v-dialog
      v-model="modalPdfStatus"
      max-width="1000px"
			persistent
      scrollable
    >
      <v-card min-height="90vh">
        <v-card-title class="pa-0">
            <div class="d-flex flex-row flex-grow-1 align-center justify-space-between py-2 px-8">
							<div class="d-flex flex-row align-center justify-start">
								<v-icon color="#959595" class="mr-2">mdi-file-pdf-box</v-icon>
								<p class="mb-0 font-weight-bold text-primary body-1">{{report.budget ? 'Presupuesto Desarchivo':'Informe'}}</p>
							</div>
							<div class="d-flex align-center">
								<div class="d-flex align-center" v-if="isClient">
									<v-tooltip bottom v-if="!report.budget?.payment_order">
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												outlined
												dark
												x-small
												color="#959595"
												class="mx-1"
												@click.stop="startPaymentUnarchive"

												v-bind="attrs"
												v-on="on"
											>
												<v-icon small dark>mdi-credit-card-outline</v-icon>
												<p class="mb-0 ml-2 caption">Pagar Desarchivo</p>
											</v-btn>
										</template>
										<span>Pagar Desarchivo</span>
									</v-tooltip>
									<v-tooltip bottom v-else-if="report.last_status?.status < budgetStatuses.ACEPTADO">
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												dark
												x-small
												color="success"
												class="mx-1"
												@click.stop="startAcceptReport"

												v-bind="attrs"
												v-on="on"
											>
												<v-icon small dark>mdi-check</v-icon>
												<p class="mb-0 ml-2 caption">Aceptar Informe</p>
											</v-btn>
										</template>
										<span>Con esto podrás indicar a la contraparte que aceptas el informe y sus costos</span>
									</v-tooltip>
								</div>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											small
											color="#959595"
											@click="$store.commit('reports/setReportPdfModal', null)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon dark>mdi-close</v-icon>
										</v-btn>
									</template>
									<span>Cerrar</span>
								</v-tooltip>
							</div>
						</div>
				</v-card-title>
				<v-card-text class="pa-0">
					<iframe
						v-if="reportPdf"
						:src="reportPdf"
						width="100%"
						allow="fullscreen"
						allowfullscreen
						class="fill-height d-flex flex-grow-1"></iframe>
        </v-card-text>
        <v-card-actions class="pa-0" v-if="isViewerOnly">
					<div class="d-flex flex-grow-1 justify-end py-2 px-8">
						<v-text-field
							v-model="cc_report"
							label="Enviar con copia (Separa los correos por coma)"
							placeholder="Enviar con copia (Separa los correos por coma)"
							outlined
							required
							hide-details
							dense
							class="mr-4 w-100 custom-height-search custom-height-calendar"
						></v-text-field>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									color="green"
									class="mb-0"
									small
									v-bind="attrs"
									v-on="on"
									dark
									v-if="canSendEmail"
									@click="sendEmail"
								>
									<v-icon small>mdi-email-outline</v-icon>
									<p class="mb-0 ml-2 caption">Enviar por Email a Cliente</p>
								</v-btn>
							</template>
							<span>Se enviará correo al usuario con una copia del informe</span>
						</v-tooltip>
					</div>
				</v-card-actions>
      </v-card>
    </v-dialog>
		<AcceptCancelModal
			:closeModal="closeModalAcceptRejectModal"
			:acceptRejectModal="acceptRejectModal"
			:acceptRejectModalData="acceptRejectModalData"
		/>
  </div>
</template>

<script>
import { budgetStatuses } from '@/components/Helpers/Constants/budget'
import { sendReportPdfEmail, updateReport } from '@/helpers/api/reports'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import AcceptCancelModal from '@/components/Modals/General/AcceptCancelModal'

export default {
  name: 'ReportPdfModal',
	components: { AcceptCancelModal },
  data: () => ({
		budgetStatuses,
		indexModal: + new Date(),
		cc_report: null,
		acceptRejectModal: false,
		acceptRejectModalData: null
  }),
  computed: {
		isClient(){
			const modal = this.$store.state.reports?.reportPdfModal
			return modal && modal.is_client
		},
		isViewerOnly(){
			const modal = this.$store.state.reports?.reportPdfModal
			return !(modal && modal.viewer_only)
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		modalPdfStatus(){
			return !!this.$store.state.reports.reportPdfModal
		},
		reportPdf(){
			// return 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
			if(this.$store.state.reports.reportPdfModal?.forced_pdf){
				return this.$store.state.reports.reportPdfModal?.forced_pdf.file.file_link
			}
			return this.$store.state.reports.reportPdfModal.pdf.file.file_link
		},
		canSendEmail(){
			return true
			// return this.$store.state.contracts.contractPdfModal?.last_status?.status <= contractStatuses.OBSERVADO_CONTRAPARTE ||  this.$store.state.contracts.contractPdfModal?.last_status?.status <= contractStatuses.RECHAZADO   
		},
		report(){
			return this.$store.state.reports.reportPdfModal
		}
	},
	watch: {
	},
  mounted(){
  },
  methods: {
		startAcceptReport(){
			this.acceptRejectModalData = {
				title: 'Aceptar Informe',
				content_a: 'Al aceptar el informe este se marcará como confirmado y los costos asociados que se indiquen en podrán ser procesados de acuerdo al proyecto.',
				content_b: '¿Desea aceptar este informe?',
			}
			this.acceptRejectModal = true
		},
		async acceptReport(){
			const data = {
				report_id: this.report.id,
				new_status: budgetStatuses.ACEPTADO
			}
			const updateStatus = await updateReport(data)
			if(updateStatus.code == 200){
				const update_data = {report_id: this.report.id}
				eventBus.$emit('reloadInformation', update_data)
				this.$store.commit('reports/setReportPdfModal', null)
				const messageData = {
					message: 'Se ha aceptado correctamente el informe',
					title: 'Informe aceptado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.$store.dispatch('general/addMessage', messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', messageData)
			}
		},
		startPaymentUnarchive(){
			if(this.report.budget?.id){
				const url = 'https://apiarq.insomnia.cl/report-budget-confirm?rb=' + this.report.budget?.id;
				window.open(url, '_blank').focus();
			}
		},
		closeModalAcceptRejectModal(data){
			if(data){
				this.acceptReport()
			}
			this.acceptRejectModalData = null
			this.acceptRejectModal = false
		},
		async sendEmail(){
			if(this.report.pdf){
				try {
					await sendReportPdfEmail({report_id: this.report.id, cc_report: this.cc_report})
					const data = {report_id: this.report.id}
					eventBus.$emit('reloadInformation', data)
					const messageData = {
						message: 'Se ha enviado correctamente el correo al cliente',
						title: 'Correo enviado',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.$store.dispatch('general/addMessage', messageData)
					this.$store.commit('reports/setReportPdfModal', null)
				} catch (error) {
					const messageData = {
						message: 'Hubo un error en la operación, por favor intenta nuevamente',
						title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
					}
					this.$store.dispatch('general/addMessage', messageData)
				}
			}
		}
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>